import { TTS } from '@/components/Accessibility/speechSynthesizer';

import { getDeviceAdId } from '@/utils/getDeviceAdId';

import { Keys, NetworkCallback, System } from '../index';

function registeredKeys() {
  return {
    UP: 38,
    DOWN: 40,
    LEFT: 37,
    RIGHT: 39,
    OK: 13,
    BACK: 10009,
    SELECT: 65376,
  };
}

export const system: System = {
  id: 'ps5',
  init: () => {
    console.log('PS5 System');
    isTTSEnabled().then((enabled) => {
      system.overrideAria = enabled;
      if (enabled) TTS.init();
    });
  },
  version: () => 'ps5.1.0.0',
  script: () => {
    return <></>;
  },
  keyThrottleDelay: 100,
  key: (keyboardEvent) => {
    const deviceKeys = registeredKeys();
    switch (keyboardEvent.keyCode) {
      case deviceKeys.UP:
        return Keys.UP;
      case deviceKeys.DOWN:
        return Keys.DOWN;
      case deviceKeys.LEFT:
        return Keys.LEFT;
      case deviceKeys.RIGHT:
        return Keys.RIGHT;
      case deviceKeys.OK:
        return Keys.OK;
      case deviceKeys.SELECT:
        return Keys.OK;
      case 27:
      case deviceKeys.BACK:
        return Keys.BACK;
      default:
        return Keys.UNKNOWN;
    }
  },

  getDeviceId: async () => {
    return '';
  },

  getErrorCodePrefix: () => 'F',
  closeApp: () => {},
  getDeviceAdId: async () => {
    return getDeviceAdId();
  },
  getAdIdType: async () => {
    return '';
  },
  getIsLimitedAdTracking: async () => {
    // TODO: Determine if PS5 ad tracking is enabled
    return true;
  },
  monitorConnectionStatus: (callback: NetworkCallback) => {
    const onOffline = () => {
      callback(false);
    };
    const onOnline = () => {
      callback(true);
    };

    window.addEventListener('offline', onOffline);
    window.addEventListener('online', onOnline);
    return () => {
      window.removeEventListener('offline', onOffline);
      window.removeEventListener('online', onOnline);
    };
  },
  hasPointer: false,
  disableExitPrompt: true,
  overrideAria: false,
};

async function isTTSEnabled(): Promise<boolean> {
  //@ts-ignore
  if ((window as any)?.msdk?.system?.getTextToSpeechSettings) {
    const { enabled } = await (window as any).msdk.system.getTextToSpeechSettings();
    return enabled;
  }
  return false;
}
